// src/utils/iconMap.js
import {
  faBan,
  faCheckCircle,
  faExclamationTriangle,
  faHourglassHalf
  // Ajoutez ici toutes les icônes 'solid' que votre backend pourrait envoyer
} from '@fortawesome/free-solid-svg-icons';

// Cet objet fera la correspondance entre la chaîne du backend et l'objet icône réel
export const iconMap = {
  // Icônes Solid
  'ban': faBan,
  'check-circle': faCheckCircle,
  'exclamation-triangle': faExclamationTriangle,
  'hourglass-half': faHourglassHalf
};